// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1nJ3N","buttons":"Footer_buttons__3mkWP"};